// removed by extract-text-webpack-plugin
module.exports = {"illustration":"illustration___2hS21","small":"small___zHpK3","short":"short___2JzqS","medium":"medium___14wzD","grande":"grande___1jGcK","big":"big___2Njb9","primary":"primary___1ZfuY","secondary":"secondary___1g-gP","terciary":"terciary___1ofTv","correct":"correct___3uAyP","wrong":"wrong___25RJD","accent":"accent___iWf1C","brand":"brand___1evtU","fill":"fill___3Uil4","negative":"negative___38XUG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/index.scss
// module id = 85
// module chunks = 0